import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.farmerCode ? row.farmerCode : ""}
        </TableCell>
        <TableCell component="th" scope="row">
          {row.farmerName ? row.farmerName : ""}
        </TableCell>
        <TableCell component="th" scope="row">
          {row.workingArea ? row.workingArea : ""}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Tipe</TableCell>
                    <TableCell>Nama</TableCell>
                    <TableCell>Total Estimasi</TableCell>
                    <TableCell>Total Panen</TableCell>
                    <TableCell>Deviasi</TableCell>
                    <TableCell>Deskripsi</TableCell>
                    <TableCell>Satuan</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.listEstimatedHarvest.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>
                          {item.vegetableType ? item.vegetableType : ""}
                        </TableCell>
                        <TableCell>
                          {item.vegetableName ? item.vegetableName : ""}
                        </TableCell>
                        <TableCell>
                          {item.totalHarvestEstimate
                            ? item.totalHarvestEstimate
                            : ""}
                        </TableCell>
                        <TableCell>
                          {item.unitWeight ? item.unitWeight : ""}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.object,
  index: PropTypes.number,
};

export default function SpvReportHarvestEstimateFarmerTable({ data }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead style={{ background: "#499178" }}>
          <TableRow style={{ color: "white" }}>
            <TableCell />
            <TableCell style={{ color: "white" }}>Kode</TableCell>
            <TableCell style={{ color: "white" }}>Nama</TableCell>
            <TableCell style={{ color: "white" }}>Area</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <Row key={index} row={row} index={index} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

SpvReportHarvestEstimateFarmerTable.propTypes = {
  data: PropTypes.array,
};
